module.exports = __webpack_public_path__ + "static/media/polygon.543bcf48.svg";